import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AppApis } from '@app/core/APIs/app-apis';
import type {
  DocumentAssetCatalog,
  DocumentAssetReference,
  DocumentAssetScope,
  DocumentAssetUploadRequest,
  DocumentAssetVersion,
  DocumentBrandSaveRequest,
  DocumentBrandVersion,
  DocumentBrandReference,
  DocumentAssetManifest,
} from './document-assets.models';
const options = {
  withCredentials: true,
  headers: new HttpHeaders({
    'skip-error-interceptor': 'yes',
    'skip-loading-interceptor': 'yes',
  }),
};
@Injectable({ providedIn: 'root' })
export class DocumentAssetsService {
  private readonly http = inject(HttpClient);
  private readonly apis = inject(AppApis);
  private get url(): string {
    return this.apis.core.manual.getPlatformDocumentAssets();
  }
  catalog(scope?: Pick<DocumentAssetScope, 'scopeTypeCode' | 'scopeKey'>) {
    let params = new HttpParams();
    if (scope) {
      params = params.set('scopeTypeCode', scope.scopeTypeCode);
      if (scope.scopeKey !== null)
        params = params.set('scopeKey', scope.scopeKey);
    }
    return this.http.get<DocumentAssetCatalog>(this.url, {
      ...options,
      params,
    });
  }
  upload(request: DocumentAssetUploadRequest) {
    return this.http.post<DocumentAssetVersion>(
      `${this.url}/versions`,
      request,
      options,
    );
  }
  saveBrand(request: DocumentBrandSaveRequest) {
    return this.http.post<DocumentBrandVersion>(
      `${this.url}/brands`,
      request,
      options,
    );
  }
  exportBrand(reference: DocumentBrandReference) {
    return this.http.get<DocumentAssetManifest>(
      `${this.url}/brands/${encodeURIComponent(reference.brandId)}/versions/${reference.version}/export`,
      { ...options, params: new HttpParams().set('sha256', reference.sha256) },
    );
  }
  importManifest(
    requestId: string,
    scope: DocumentAssetScope,
    manifest: DocumentAssetManifest,
  ) {
    return this.http.post<DocumentBrandVersion>(
      `${this.url}/import`,
      {
        requestId,
        scopeTypeCode: scope.scopeTypeCode,
        scopeKey: scope.scopeKey,
        manifest,
      },
      options,
    );
  }
  content(reference: DocumentAssetReference) {
    return this.http.get(
      `${this.url}/${encodeURIComponent(reference.assetId)}/versions/${reference.version}/content`,
      {
        ...options,
        params: new HttpParams().set('sha256', reference.sha256),
        responseType: 'arraybuffer',
      },
    );
  }
}
